<div class="modal-header">
    <h2 class="modal-title">{{ title | translate }}</h2>
</div>
<div class="modal-footer">
    <div class="d-flex flex-grow-1 justify-content-between px-3">
        <button
            type="button"
            class="btn custom-btn"
            (click)="buttonClicked(false)">
            {{ 'specialOffers.common.btn1' | translate }}
        </button>
        <button
            type="button"
            class="btn primary-btn custom-btn"
            (click)="buttonClicked(true)">
            {{ 'specialOffers.common.btn2' | translate }}
        </button>
    </div>
</div>